<div class="form-dialog-root">

  <mat-toolbar class="form-dialog-toolbar">
    <span class="toolbar-title">{{ dialogTitle }}</span>
  </mat-toolbar>

  <div class="form-dialog-body">
    <ng-template injectComp></ng-template>
  </div>

</div>
